import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    addAdminButtonLabel: 'Add Admin',
    cancelButtonLabel: 'Cancel',
    changePasswordTitle: 'Change Password',
    createAccountTitle: 'Create Account',
    createdAtLabel: 'Created At',
    createdDate: 'Created Date',
    currentPasswordLabel: 'Current Password',
    deleteModalTitle: 'Are you sure you want to delete this admin?',
    editAccountTitle: 'Edit Account',
    emailLabel: 'Email',
    emailValidation: 'Email must be valid',
    eventLogTitle: 'Event Log',
    firstNameLabel: 'First Name',
    fullNameLabel: 'Full Name',
    lastLoginLabel: 'Last Sign In At',
    lastNameLabel: 'Last Name',
    loginCountLabel: 'Sign In Count',
    nameLabel: 'Name',
    newPasswordLabel: 'New Password',
    note: 'Note: once you have changed your password you will be logged out.',
    passwordLabel: 'Password',
    phoneNumberLabel: 'Phone Number',
    profileInformation: 'Profile Information',
    requiredValidation: 'This field is required',
    resourceName: 'Admin',
    submitButtonLabel: 'Submit New Password',
    updatedDate: 'Updated Date',
  },
})
